import { render, staticRenderFns } from "./FilePondComponent.vue?vue&type=template&id=84ad5dfe&"
import script from "./FilePondComponent.vue?vue&type=script&lang=js&"
export * from "./FilePondComponent.vue?vue&type=script&lang=js&"
import style0 from "./FilePondComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports